module.exports = __webpack_public_path__ + "img/github-icon.dbb2ff06.svg";